import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.frameTarget.addEventListener("load", () => this.scaleToFit())
  }

  scaleToFit() {
    try {
      const doc = this.frameTarget.contentDocument
      const contentWidth = doc.documentElement.scrollWidth
      const contentHeight = doc.documentElement.scrollHeight
      const containerWidth = this.element.clientWidth

      const scale = containerWidth / contentWidth

      this.frameTarget.style.width = `${contentWidth}px`
      this.frameTarget.style.height = `${contentHeight}px`
      this.frameTarget.style.transform = `scale(${scale})`
      this.frameTarget.style.transformOrigin = "top left"
      this.element.style.height = `${contentHeight * scale}px`
    } catch (_) {
      // cross-origin fallback: keep the CSS height
    }
  }
}
